import { supabaseClient } from 'supabase'
import { DeskTabValue } from './deskTypes'
import { deskTabOrder } from './queryDeskQueue'

export type QueryDeskNextCandidateParams = {
  tab: DeskTabValue
  excludeId: number
}

/**
 * The candidate to open after a decision (UI-SPEC U-03): the first row of the
 * same tab, in the list's own order, that is not the one just decided. Returns
 * null when the tab has no other candidate; the caller then goes back to the
 * list.
 *
 * Rows with no application (a raw item the editor discarded, discard pile
 * only) have no candidate screen, so they are skipped with `.not(... is null)`.
 * The neq alone would also drop them (SQL `NULL <> x` is not true), but the
 * intent is spelled out rather than left to that.
 */
export const queryDeskNextCandidate = async ({
  tab,
  excludeId
}: QueryDeskNextCandidateParams): Promise<number | null> => {
  let query = supabaseClient
    .from('desk_queue')
    .select('application_id')
    .eq('desk_tab', tab)
    .not('application_id', 'is', null)
    .neq('application_id', excludeId)

  for (const { column, options } of deskTabOrder(tab)) {
    query = query.order(column, options)
  }

  const { data, error } = await query.limit(1)

  if (error) {
    throw error
  }
  return data?.[0]?.application_id ?? null
}
